import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveSchool } from 'actions/user';
import { reloadSchoolActions, reloadSchoolProps } from 'components/SchoolSwitch/SchoolSwitch';
import { translate } from '@haldor/ui';
import swal from 'sweetalert2';

var ConditionReceiver = /*#__PURE__*/function (_Component) {
  _inherits(ConditionReceiver, _Component);

  var _super = _createSuper(ConditionReceiver);

  function ConditionReceiver(props) {
    var _this;

    _classCallCheck(this, ConditionReceiver);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url, schoolId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _this.getParameterByName('url', _this.props.location.search);
              schoolId = _this.getParameterByName('schoolId', _this.props.location.search);

              if (!(url != null && schoolId != null)) {
                _context.next = 5;
                break;
              }

              _this.verifySchool(schoolId, url);

              return _context.abrupt("return");

            case 5:
              // fallback
              _this.props.history.replace(url != null ? url : "");

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "verifySchool", function (schoolId, url) {
      if (schoolId != _this.props.activeSchool) {
        swal.fire({
          title: _this.props.translate('Switch active school?'),
          text: _this.props.translate("This information can't be viewed with the current school. Do you want to switch active school?"),
          showCancelButton: true,
          focusConfirm: false,
          cancelButtonText: _this.props.translate('No'),
          confirmButtonText: _this.props.translate('Yes')
        }).then(function (result) {
          if (result.value != null) {
            _this.switchSchool(schoolId);

            _this.props.history.replace(url);
          } else {
            _this.props.history.goBack();
          }
        });
      } else {
        _this.props.history.replace(url);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "switchSchool", function (schoolId) {
      localStorage.setItem('hal.school' + _this.props.currentUser.id, schoolId);

      _this.props.setActiveSchool(schoolId);

      reloadSchoolProps(_this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });

    return _this;
  }

  _createClass(ConditionReceiver, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return ConditionReceiver;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    activeSchool: state.user.activeSchool
  };
}

export default withRouter(connect(mapStateToProps, _objectSpread({
  setActiveSchool: setActiveSchool
}, reloadSchoolActions))(ConditionReceiver));